import { createRoute } from "@tanstack/react-router";
import { Route as rootRoute } from "./root";
import { api } from "@lib/client";

export type PageProps = {
  id: string;
  title: string;
  html: string;
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/flow/page/$pageId",
  loader: async ({ params }): Promise<PageProps> => {
    const res = await api.page[":pageId"].$get({
      param: { pageId: params.pageId },
    });
    if (!res.ok) {
      throw new Response("Page not found", { status: 404 });
    }

    const data = (await res.json()) as {
      success: boolean;
      page: PageProps;
    };
    if (!data.success) {
      throw new Response("Page not found", { status: 404 });
    }

    return data.page;
  },
  component: function Page() {
    const props = Route.useLoaderData();
    return (
      <div className="border shadow-lg shadow-gray-300 border-gray-100 rounded-lg max-w-[800px] mx-auto my-20 bg-white">
        <div className="flex flex-col items-center justify-between p-6">
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: props.html }}
          />
        </div>
      </div>
    );
  },
});
